import {useReducer} from "react";

import {SwapFlowDispatchContext, SwapFlowStateContext} from "./context/SwapFlowContext";
import {initialSwapFlowState} from "./context/SwapFlowContext.contants";
import {swapFlowStateReducer} from "./context/swapFlowStateReducer";
import {useOnSelectedAccountAddressChange} from "../../wallet/util/context/WalletContext.utils";
import {SwapFlowView} from "./context/SwapFlowContext.types";

interface SwapFlowProps {
  children?: React.ReactNode;
}

function SwapFlow({children}: SwapFlowProps) {
  const [state, dispatch] = useReducer(swapFlowStateReducer, initialSwapFlowState);

  useOnSelectedAccountAddressChange(() => {
    dispatch({type: "SET_VIEW", view: SwapFlowView.Form});
  });

  return (
    <SwapFlowDispatchContext.Provider value={dispatch}>
      <SwapFlowStateContext.Provider value={state}>
        {children}
      </SwapFlowStateContext.Provider>
    </SwapFlowDispatchContext.Provider>
  );
}

export default SwapFlow;
